import z, { type RefinementCtx } from "zod";
import type { Nullable, ServerSet, Tables } from "../../../types";
import type { HonoClient } from "../../types";
import { ZodServerSetString } from "../../zod-types/zod-server-set";

export const verifyProjectNumberSchema = z.object({
	workspaceId: z.string().min(1),
	number: ZodServerSetString.or(z.string().min(1)),
	projectId: z.string().or(z.null()).default(null),
});

export function refineVerifyProjectNumberSchema(client: HonoClient) {
	return async (
		values: Omit<ServerSet<Tables<"projects">>, "number"> & {
			number: Nullable<string>;
		},
		context: RefinementCtx,
	) => {
		if (!values.number) return;
		const res = await client.projects.verify["project-number"].$get({
			query: {
				projectId: values.id,
				projectNumber: values.number,
				workspaceId: values.workspaceId,
			},
		});
		const json = await res.json();
		if (!json.isValid) {
			context.addIssue({
				path: ["number"],
				message: json.message,
				code: "custom",
			});
		}
	};
}
